"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChallengeSubtype = exports.ChallengeType = void 0;
var ChallengeType;
(function (ChallengeType) {
    ChallengeType["MakeFairway"] = "MakeFairway";
    ChallengeType["MakeTheGreen"] = "MakeTheGreen";
    ChallengeType["LessThan10FtFromPin"] = "LessThan10FtFromPin";
    ChallengeType["TeeShotOver220YardsOnFairway"] = "TeeShotOver220YardsOnFairway";
    ChallengeType["NoBunkers"] = "NoBunkers";
    ChallengeType["NoRough"] = "NoRough";
    ChallengeType["NoWater"] = "NoWater";
})(ChallengeType = exports.ChallengeType || (exports.ChallengeType = {}));
var ChallengeSubtype;
(function (ChallengeSubtype) {
    ChallengeSubtype["MakeFairwayIn1"] = "MakeFairwayIn1";
    ChallengeSubtype["MakeTheGreenIn1"] = "MakeTheGreenIn1";
    ChallengeSubtype["MakeTheGreenIn2"] = "MakeTheGreenIn2";
    ChallengeSubtype["MakeTheGreenIn3"] = "MakeTheGreenIn3";
    ChallengeSubtype["LessThan10FtFromPinIn1"] = "LessThan10FtFromPinIn1";
    ChallengeSubtype["LessThan10FtFromPinIn2"] = "LessThan10FtFromPinIn2";
    ChallengeSubtype["LessThan10FtFromPinIn3"] = "LessThan10FtFromPinIn3";
    ChallengeSubtype["TeeShotOver220YardsOnFairway"] = "TeeShotOver220YardsOnFairway";
    ChallengeSubtype["NoBunkers"] = "NoBunkers";
    ChallengeSubtype["NoRough"] = "NoRough";
    ChallengeSubtype["NoWater"] = "NoWater";
})(ChallengeSubtype = exports.ChallengeSubtype || (exports.ChallengeSubtype = {}));
//# sourceMappingURL=ChallengeTypes.js.map